<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Demandes</span>
        <h3 class="page-title">{{ $t("minibus.managment.page.title") }}</h3>
      </div>
    </div>
    <!-- Table -->
    <div class="row">
      <div class="col">
        <div
          class="card card-small mb-4 mt-3"
          v-if="loading || !user.connected"
        >
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <div v-else>
          <div class="card card-small mb-4 mt-3">
            <div class="header-data-table d-flex justify-content-between">
              <h5 class="header-data-table__heading">{{ $t("minibus.managment.page.subtitle") }}</h5>
              <div class="d-flex">
                  <button class="btn btn-warning float-right mr-3" @click="goToPlanning()">
                    {{ $t("minibus.managment.see.planning.button") }}
                  </button>
                  <button class="btn btn-success float-right" @click="goToManuelReservation()">
                    {{ $t("minibus.managment.page.manuel.button") }}
                  </button>
              </div>
            </div>
            <LeaveRequestFilter :statusList="statusList" />
            <div class="card-body">
              <data-table
                :data="minibusGridData"
                :fields="gridColumnsTitle"
                :selectedFields="MinibusRequestManagmentFields"
                :fieldsGrid="gridColumnsFields"
                :tableState="state"
                :count="count"
              ></data-table>
            </div>
          </div>
        </div>
        <simple-modal ref="reasonModal" :motif="selectedMotif" />
      </div>
    </div>
  </div>
</template>

<script>
import TimeUtils from "../../utils/TimeUtils";
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import DataTable from "../../components/dataTable/dataTable";
import SimpleModal from "../../components/abscenceRequest/SimpleModal";
import minibusRequestGrid from "../../data/dataTable/minibusRequestGrid.json";
import LeaveRequestFilter from "./MinibusRequestFilter.vue";
import ChangeDateDialog from "../absenceRequest/ChangeDateDialog.vue";
import Long from "long";

export default {
  components: {
    SimpleModal,
    DataTable,
    SpinnerDot,
    LeaveRequestFilter,
    ChangeDateDialog
  },
  props: ["reference"],
  data() {
    return {
      dialog: false,
      minibusHistory: [],
      requestToEdit: {},
      count: 0,
      model: {},
      beneficiary: {
          firstName: "",
          lastName: "",
          isExternalPerson: false
      },
      selectedMotif: "",
      // all values available for the table
      gridColumnsFields: minibusRequestGrid.grid,
      gridColumnsTitle: minibusRequestGrid .grid.map(grid => grid.title),
      loading: true,
      MinibusRequestManagmentFields: [
        "Bénéficiaire",
        "Titre",
        "Destination",
        "Date de création",
        "Date de début",
        "Date de fin",
        "Status",
        "Action"
      ],
      hours: [
                '00',
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
            ],
      MinibusRequestManagmentFieldsGridFill: {
        "Bénéficiaire": request => request.isExternalClient ? `${request.firstName} ${request.lastName} (PE)` : `${request.userFirstName} ${request.userLastName}`,
        "Titre": request => request.title,
        "Destination": request => request.destination,
        "Date de création": request => new Date(parseInt(new Long(request.creationDate.low, request.creationDate.high, request.creationDate.unsigned).toNumber())).toLocaleDateString("fr-FR"),
        "Date de début": request => new Date(request.fromDate).toLocaleDateString("fr-FR") + `  (${this.hours[parseInt(request.fromDate.split('T')[1].split(':')[0]) + 1]}:${new Date(request.fromDate).getMinutes() ? new Date(request.fromDate).getMinutes() : "00"})`,
        "Date de fin": request => new Date(request.toDate).toLocaleDateString("fr-FR")  + `  (${this.hours[parseInt(request.toDate.split('T')[1].split(':')[0]) + 1]}:${new Date(request.toDate).getMinutes() ? new Date(request.toDate).getMinutes() : "00"})`,
        "Status": request => request.answers[0].status || "En attente...",
        Action: request => {
          return [
            {
              component: "button-td",
              class: "btn-accent",
              content: "Voir la demande",
              action: () => this.goToLeaveRequest(request),
              id: request.declineReason
            }
          ];
        }
      },
      state: {
        page: 1,
        perPage: 10,
        field: "Date de cr�ation",
        ascending: false
      },
      statusList: ["PENDING", "ACCEPTED", "REFUSED"],
      filterQuery: {},
      filteredMinibusRequest: [],
      minibusGridData: []
    };
  },

  watch: {
    state: {
      handler() {
        this.minibusFetch();
      },
      deep: true
    },
    filterQuery() {
      // searchMinibusFetch
      if (Object.keys(this.filterQuery).length === 0) {
        this.minibusFetch();
      } else {
        this.searchMinibusFetch();
      }
    },
    minibusHistory() {
      if (this.filterQuery.dates) {
        const { from, to } = this.filterQuery.dates;
        const filtered = this.minibusHistory.filter(item => {
          const { fromDate, toDate } = item;
          if (from && to) {
            return new Date(fromDate).getTime() >= from && new Date(toDate).getTime() <= to;
          } else if (!from) {
            return new Date(toDate).getTime() <= to;
          } else if (!to) {
            return new Date(fromDate).getTime() >= from;
          }
          return true;
        });
        this.filteredMinibusRequest = this.filterQuery.status
          ? this.filterQuery.status === "PENDING"
            ? filtered.filter(item => item.status === this.filterQuery.status)
            : filtered.filter(item => item.status === this.filterQuery.status)
          : filtered;
      } else {
        this.filteredMinibusRequest = this.filterQuery.status
          ? this.filterQuery.status === "PENDING"
            ? this.minibusHistory.filter(item => item.status === this.filterQuery.status)
            : this.minibusHistory.filter(
                item => item.status === this.filterQuery.status
              )
          : this.minibusHistory;
      }
    },
    filteredMinibusRequest() {
      this.minibusGridData = this.filteredMinibusRequest.map(user => {
        const res = {};
        this.MinibusRequestManagmentFields.forEach(field => {
          if (this.MinibusRequestManagmentFieldsGridFill[field]) {
            res[field] = this.MinibusRequestManagmentFieldsGridFill[field](user);
          }
        });
        return res;
      });
    }
  },

  computed: {
    user() {
      return this.$store.state.user.informations;
    }
  },

  methods: {
    formatTime(date) {
      return TimeUtils.formatTime(date);
    },
    goToManuelReservation() {
      this.$router.push("/demandes/minibus/manuel");  
    },
    goToPlanning() {
      this.$router.push({name : "minibus-planning", params : {reference : "All"}});  
    },
    goToLeaveRequest(request) {
        this.$router.push(`/demandes/minibus/management/demand/${request.reference}`);
    },
    async minibusFetch() {
      this.loading = true;
      await this.$services.minibusRequest
        .findAll(
          this.user.reference,
          null,
          null,
          null,
          this.state.page,
          this.state.perPage,
          this.state.field,
          this.state.ascending,
          this.gridColumnsFields
        )
        .then(res => {
          this.loading = false;
          this.count = res.data.count;
          this.minibusHistory = res.data.data;
        });
    },
    async searchMinibusFetch() {
      this.loading = true;
      await this.$services.minibusRequest
        .findAll(this.user.reference,          {
            status:
              this.filterQuery.status
              ? this.filterQuery.status
              : undefined ,
            userFirstName: this.filterQuery.firstName
              ? this.filterQuery.firstName
              : undefined,
            userLastName: this.filterQuery.lastName
              ? this.filterQuery.lastName
              : undefined
          })
        .then(res => {
          this.loading = false;
          this.count = res.data.count;
          this.minibusHistory = res.data.data;
        });
    }
  },

  mounted() {
    if (!this.reference) {
      this.model = { userReference: this.user.reference };
    } else {
      this.model = { userReference: this.reference };
    }
    this.filterQuery = this.$store.state.absenceRequest.filter;
    this.minibusFetch();
    this.$root.$on("refresh", () => {
      this.minibusFetch();
    });
    this.$root.$on("searchRequests", query => {
      this.filterQuery = query;
    });
    this.$root.$on("searchRequestsOnDataBase", data => {
      this.minibusHistory = data;
    });
  }
};
</script>

<style></style>
